const Pages = {
  Default: "/",
  Dashboard: "/d",
  Login: "/login",
  ForgotPassword: "/forgot-password",
  Admin: "/admin",
  AdminDetail: "/admin/:id",
  User: "/user",
  UserForm: "/user/:id",
  UserDetail: "/user/detail/:id",
  UserWallet: "/user/detail/:id#wallet",
  Driver: "/driver",
  DriverDetail: "/driver/detail/:id",
  DriverWallet: "/driver/detail/:id#wallet",
  DriverDetailTierDetail: "/driver/detail/:id#tier",
  DriverForm: "/driver/:id",
  DriverApplication: "/driver-application",
  DriverApplicationDetail: "/driver-application/:id",
  DriverTier: "/driver-tier",
  DriverTierDetail: "/driver-tier/:id",
  VehicleType: "/vehicle-type",
  VehicleTypeDetail: "/vehicle-type/:id",
  Transaction: "/transaction",
  Order: "/order",
  OrderDetail: "/order/:id",
  RolePermission: "/role-permission",
  SystemSetting: "/system-setting",
  Broadcast: "/broadcast",
  Fare: "/fare",
  FareDetail: "/fare/:id",
  Banner: "/banner",
  BannerDetail: "/banner/:id",
  Video: "/video",
  VideoDetail: "/video/:id",
  Quiz: "/quiz",
  QuizDetail: "/quiz/:id",
  Attempt: "/attempt",
  AttemptDetail: "/attempt/:id",
  WithdrawalDriver: "/withdrawal/driver",
  WithdrawalUser: "/withdrawal/user",
  Chat: "/chat",
  Map: "/map",
  Audit: "/audit",
};

export default Pages;
